import { render } from "./DietStayRow.vue?vue&type=template&id=1f12e5f8&scoped=true"
import script from "./DietStayRow.vue?vue&type=script&lang=js"
export * from "./DietStayRow.vue?vue&type=script&lang=js"

import "./DietStayRow.vue?vue&type=style&index=0&id=1f12e5f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f12e5f8"]])

export default __exports__